import { useAppContext } from '../context/AppContext';
import { Table, Image, Text } from '@mantine/core';
import { MobileView, BrowserView } from 'react-device-detect';
import PlantShoppingListMobile from './PlantShoppingList.mobile';

const IMAGE_URL = import.meta.env.VITE_S3_PNG_URL;

const PlantShoppingList = () => {
	const { currentDesign, filteredList } = useAppContext().state;
	const { chosenPlants } = currentDesign;

	return (
		<>
			<MobileView>
				<PlantShoppingListMobile />
			</MobileView>
			<BrowserView>
				<Table striped highlightOnHover withTableBorder withColumnBorders style={{ width: 'auto', minWidth: 0, maxWidth: '100%' }}>
					<Table.Thead>
						<Table.Tr>
							<Table.Th>Image</Table.Th>
							<Table.Th style={{ width: 100 }}>Category</Table.Th>
							<Table.Th style={{ width: 100 }}>Quantity</Table.Th>
							<Table.Th style={{ minWidth: 120, maxWidth: 200 }}>Common Name</Table.Th>
							<Table.Th style={{ minWidth: 150, maxWidth: 250 }}>Botanical Name</Table.Th>
						</Table.Tr>
					</Table.Thead>
					<Table.Tbody>
						{chosenPlants.map(({ plantId, category, quantity }) => {
							const plantInfo = filteredList.find((plant) => plant.ID === plantId);
							if (!plantInfo) return null;

							return (
								<Table.Tr key={`${plantId}-${category}`}>
									<Table.Td>
										<Image
											src={`${IMAGE_URL}/${plantInfo.ImageURL}.png`}
											alt={plantInfo.Common}
											width={80}
											height={80}
											fit="contain"
										/>
									</Table.Td>
									<Table.Td style={{ width: 100 }}>
										<Text size="sm">{category}</Text>
									</Table.Td>
									<Table.Td style={{ width: 100 }}>
										<Text size="sm">{quantity}</Text>
									</Table.Td>
									<Table.Td>
										<Text size="sm" style={{ minWidth: 120, maxWidth: 200 }}>{plantInfo.Common}</Text>
									</Table.Td>
									<Table.Td style={{ minWidth: 150, maxWidth: 250  }}>
										<Text size="sm" fs="italic">{plantInfo.Botanical}</Text>
									</Table.Td>
								</Table.Tr>
							);
						})}
					</Table.Tbody>
				</Table>
			</BrowserView>
		</>
	);
};

export default PlantShoppingList;
